import React from "react";
import TableContainer from "./TableContainer";

//Import Breadcrumb

const Table = ({ header, data, filter, addButtonTite, addLink, getLengthPage, totalPage, children, open, SetOpen, customToolsBar, checkedAll, setCheckedAll, module, pageSize, 
  sort, setSorted, sort_by, setSortBy }) => {
  return (
    <React.Fragment>
      <TableContainer
        columns={header || []}
        data={data || []}
        module={module}
        isPagination={true}
        filter={filter}
        customToolsBar={customToolsBar}
        addButtonTite={addButtonTite}
        addLink={addLink}
        getLengthPage={getLengthPage}
        // isGlobalFilter={false}
        // iscustomPageSize={false}
        isBordered={false}
        customPageSize={pageSize}
        totalPage={totalPage}
        children={children}
        open={open}
        SetOpen={SetOpen}
        checkedAll={checkedAll}
        setCheckedAll={setCheckedAll}
        sort={sort}
        setSorted={setSorted}
        sort_by={sort_by}
        setSortBy={setSortBy}
      />
    </React.Fragment>
  );
};

export default Table;
